import React, { useEffect, useState } from 'react';

import { filterMethod } from '../../Helpers/helpers';

import { Autocomplete, TextField } from '@mui/material';

const PermissionsAutocomplete = (props) => {
  const setByType = props.setByType;
  const permisionsType = props.permisionsType;
  const nameLabel = props.nameLabel;
  const size = props.size;

  const [selectedPermissionType, setSelectedPermissionType] = useState({});

  useEffect(() => {
    let Obj = findId(permisionsType, options);
    setSelectedPermissionType(Obj);
  }, [permisionsType]);

  const handleChange = (event, newValue) => {
    setByType(newValue?.name);
    setSelectedPermissionType(newValue);
  };

  return (
    <div>
      <Autocomplete
        sx={{
          width: '80%',
          background: '#ffffff',
          padding: 0,
        }}
        label={nameLabel}
        name='userName'
        key='userName'
        id='userName'
        // variant='standard'
        size={size}
        value={selectedPermissionType}
        onChange={handleChange}
        disablePortal
        options={options}
        filterOptions={filterMethod}
        getOptionLabel={(option) => option.displayName}
        renderInput={(params) => <TextField {...params} label={nameLabel} />}
      />
    </div>
  );
};

export default PermissionsAutocomplete;

const options = [
  { id: '101', name: 'manager', displayName: 'Manager' },
  { id: '102', name: 'coordinator', displayName: 'Coordinator' },
  { id: '103', name: 'technician', displayName: 'Technician' },
  { id: '104', name: 'finance', displayName: 'Finance' },
  { id: '105', name: 'subbie', displayName: 'Subbie' },
];

const findId = (item, objectSet) => {
  let found = null;
  for (let i = 0; i < objectSet.length; i++) {
    if (objectSet[i].name === item) {
      found = objectSet[i];
      break;
    }
  }
  return found;
};
